import React from "react";
import {ReactComponent as Frame11 } from "./assets/CapitalHome/frame-11.svg";
import {ReactComponent as Frame48095967 } from "./assets/CapitalHome/frame-48095967.svg";
import {ReactComponent as Frame48095969 } from "./assets/CapitalHome/frame-48095969.svg";
import {ReactComponent as Frame48095976 } from "./assets/CapitalHome/frame-48095976.svg";
import {ReactComponent as Frame48095977 } from "./assets/CapitalHome/frame-48095977.svg";
import {ReactComponent as Frame48095978 } from "./assets/CapitalHome/frame-48095978.svg";
import {ReactComponent as Frame48096060 } from "./assets/CapitalHome/frame-48096060.svg";
import {ReactComponent as IconComponentNode } from "./assets/CapitalHome/frame-11.svg";
import {ReactComponent as Intersect } from "./assets/CapitalHome/intersect.svg";
import {ReactComponent as Line13 } from "./assets/CapitalHome/line-13.svg";
import {ReactComponent as Line24 } from "./assets/CapitalHome/line-24.svg";
import {ReactComponent as Line25 } from "./assets/CapitalHome/line-25.svg";
import {ReactComponent as Vector } from "./assets/CapitalHome/vector-1.svg";
import "./style.css";
import rectangle4 from "./assets/CapitalHome/rectangle-4.png";
import group40941 from "./assets/CapitalHome/group-40941.png";
import aboutus256017061 from "./assets/CapitalHome/about-us-2560x1706-1.png";
import group40897 from "./assets/CapitalHome/group-40897.png";
import group41225 from "./assets/CapitalHome/group-41225.png";
import vector from "./assets/CapitalHome/vector.png";

export const CapitalHome = () => {
  return (
    <div className="capital-home">
      <div className="div">
        <div className="overlap">
          <div className="rectangle" />
          <img className="img" alt="Rectangle" src={rectangle4} />
          <img className="group" alt="Group" src={group40941} />
          <div className="rectangle-2" />
          <div className="inspirons-les-gens-wrapper">
            <p className="inspirons-les-gens">
              <span className="text-wrapper">
                Inspirons <br />
                les gens <br />à créer de <br />
                la{" "}
              </span>
              <span className="span">valeur</span>
            </p>
          </div>
          <div className="rectangle-3" />
          <div className="group-2">
            <div className="frame">
              <div className="overlap-group-wrapper">
                <div className="overlap-group">
                  <p className="heading-example">
                    Beatimo excelle en actuariat, cumulant des années d&#39;expérience. Nos conseils sur mesure,
                    résultat d&#39;une expertise approfondie, optimisent la gestion des risques, <br />
                    la tarification des assurances et la planification financière.
                  </p>
                  <div className="group-3" />
                </div>
              </div>
              <p className="p">
                Bénéficiez d&#39;une approche proactive assurant stabilité et rendements optimaux. Choisissez Beatimo
                pour une expertise actuarielle d&#39;élite.
              </p>
              <div className="frame-wrapper">
                <div className="frame-2">
                  <div className="div-wrapper">
                    <div className="frame-3">
                      <div className="text-wrapper-2">EN SAVOIR PLUS</div>
                    </div>
                  </div>
                  <Frame11 className="frame-11" />
                </div>
              </div>
            </div>
            <div className="frame-4">
              <div className="l-immobilier-c-est-wrapper">
                <p className="l-immobilier-c-est">
                  <span className="text-wrapper-3">
                    L&#39;immobilier,
                    <br />
                    c’est{" "}
                  </span>
                  <span className="text-wrapper-4">bien plus</span>
                  <span className="text-wrapper-3"> qu’un simple </span>
                  <span className="text-wrapper-4">investissement </span>
                  <span className="text-wrapper-3">financier.</span>
                </p>
              </div>
            </div>
          </div>
          <img className="about-us" alt="About us" src={aboutus256017061} />
          <div className="group-4">
            <div className="frame-5">
              <div className="frame-6">
                <div className="frame-7">
                  <Line13 className="line" />
                  <div className="heading-example-2">Performante</div>
                </div>
                <Frame48095967 className="frame-48095967" />
                <div className="group-5">
                  <p className="heading-example-3">
                    Nous valorisons la possibilité d&#39;investir, de contribuer à notre communauté et de nous
                    concentrer sur ce qui compte vraiment pour nous. Cela s&#39;atteint grâce à des stratégies orientés
                    vers la performance.
                  </p>
                  <Line13 className="line-13" />
                </div>
              </div>
            </div>
          </div>
          <div className="group-6">
            <div className="frame-5">
              <div className="frame-6">
                <div className="frame-7">
                  <Line13 className="line" />
                  <div className="heading-example-2">Empathique</div>
                </div>
                <div className="intersect-wrapper">
                  <Intersect className="intersect-instance" />
                </div>
                <div className="group-5">
                  <p className="heading-example-3">
                    Nous partageons les mêmes rêves que nos clients. Nous comprenons leur réalité et appliquons les
                    mêmes outils et principes que nous proposons, assurant ainsi une expérience enrichissante.
                  </p>
                  <Line13 className="line-13" />
                </div>
              </div>
            </div>
          </div>
          <div className="group-7">
            <div className="frame-5">
              <div className="frame-6">
                <div className="frame-7">
                  <Line13 className="line" />
                  <div className="heading-example-2">Experte</div>
                </div>
                <img className="group-8" alt="Group" src={group40897} />
                <div className="group-9">
                  <p className="heading-example-4">
                    Notre expertise se forge sur le terrain, allant au-delà des formations. Les projets complexes ont
                    affiné notre approche. Notre équipe, composée d&#39;actuaires et <br />
                    de passionnés, offre un accompagnement <br />
                    direct et transparent.
                  </p>
                  <Line13 className="line-13-instance" />
                </div>
              </div>
            </div>
          </div>
          <div className="rectangle-4" />
          <div className="group-wrapper">
            <div className="group-10">
              <Line24 className="line-24" />
              <div className="frame-8">
                <div className="frame-9">
                  <p className="text-wrapper-5">COPYRIGHT © 2024 BEATIMO | TOUT DROITS RÉSERVÉS</p>
                  <div className="text-wrapper-5">PRÉFÉRENCE DES TÉMOINS</div>
                  <div className="text-wrapper-5">POLITIQUES ET CONFIDENTIALITÉ</div>
                </div>
                <p className="site-par-les-mauvais">SITE PAR LES MAUVAIS GARÇONS</p>
              </div>
              <img className="group-11" alt="Group" src="group-41210.png" />
              <div className="group-12">
                <Line25 className="line-25" />
                <Line25 className="line-26" />
                <Line25 className="line-29" />
                <div className="overlap-2">
                  <div className="text-wrapper-6">01</div>
                  <div className="text-wrapper-7">Facebook</div>
                </div>
                <div className="overlap-3">
                  <div className="text-wrapper-8">03</div>
                  <div className="text-wrapper-9">LinkedIn</div>
                </div>
                <Line25 className="line-30" />
                <div className="overlap-group-2">
                  <div className="text-wrapper-10">02</div>
                  <div className="text-wrapper-9">Youtube</div>
                </div>
                <div className="overlap-4">
                  <div className="text-wrapper-10">04</div>
                  <div className="text-wrapper-9">Tiktok</div>
                </div>
                <div className="group-13">
                  <div className="frame-10">
                    <Vector className="vector-instance" color="#EEFFF6" />
                    <div className="heading-example-5">NOS RÉSEAUX SOCIAUX</div>
                  </div>
                </div>
                <Frame48095976 className="frame-48095976" />
                <Frame48095977 className="frame-48095977" />
                <Frame48095978 className="frame-48095978" />
                <IconComponentNode className="frame-11-instance" />
              </div>
            </div>
          </div>
          <div className="rectangle-5" />
          <div className="frame-12">
            <div className="frame-13">
              <div className="frame-14">
                <Vector className="vector-instance" color="#EEFFF6" />
                <div className="heading-example-6">NOUS JOINDRE</div>
              </div>
              <p className="heading">
                <span className="text-wrapper-11">Curieux </span>
                <span className="text-wrapper-12">
                  de savoir <br />
                  ce que nous pouvons faire pour{" "}
                </span>
                <span className="text-wrapper-11">vous?</span>
              </p>
            </div>
            <div className="frame-wrapper">
              <div className="frame-2">
                <div className="frame-15">
                  <div className="frame-3">
                    <div className="text-wrapper-2">ENTRER EN CONTACT</div>
                  </div>
                </div>
                <Frame11 className="frame-11" />
              </div>
            </div>
          </div>
          <img className="vector-2" alt="Vector" src={vector} />
          <div className="group-14">
            <p className="maximisez-la">
              <span className="text-wrapper-3">Maximisez la </span>
              <span className="text-wrapper-11">Performance</span>
              <span className="text-wrapper-3">
                {" "}
                de <br />
                Vos Investissements
              </span>
            </p>
            <div className="frame-16">
              <p className="heading-example-7">
                Grâce à une approche personnalisée et une analyse actuarielle approfondie, nous vous guidons dans la
                prise de décisions éclairées pour atteindre vos objectifs financiers. Que vous soyez un investisseur
                novice ou expérimenté, nous sommes là pour vous aider à naviguer dans le marché immobilier avec
                confiance et succès.
              </p>
              <div className="frame-wrapper">
                <div className="frame-2">
                  <div className="frame-15">
                    <div className="frame-3">
                      <div className="text-wrapper-2">DÉCOUVRIR BEATIMO</div>
                    </div>
                  </div>
                  <Frame11 className="frame-11" />
                </div>
              </div>
            </div>
            <div className="frame-17">
              <Vector className="vector-instance" color="#FFFAE6" />
              <div className="heading-example-6">À PROPOS DE BEATIMO</div>
            </div>
          </div>
          <div className="frame-18">
            <Frame48096060 className="frame-48096060" />
            <div className="frame-19">
              <div className="frame-20">
                <div className="text-wrapper-13">À PROPOS</div>
                <div className="text-wrapper-13">RÉSEAUX SOCIAUX</div>
                <div className="text-wrapper-13">EN</div>
              </div>
              <img className="group-15" alt="Group" src={group41225} />
            </div>
          </div>
        </div>
        <div className="overlap-5">
          <Frame48095969 className="frame-48095969" />
          <Frame48095969 className="frame-48095969" />
          <Frame48095969 className="frame-48095969" />
          <Frame48095969 className="frame-48095969" />
          <Frame48095969 className="frame-48095969" />
          <Frame48095969 className="frame-48095969" />
        </div>
      </div>
    </div>
  );
};
export default CapitalHome;